import React from "react";
import {wellClassFormatter} from "./PlateMapCellFormatter";

export const TanStackEditableCellComponent: React.FC<{
    value: string;
    row: any;
    column: string;
    onValueChange: (value:string, row: any, column: string) => void;
    options: { value: string, label: string }[];
    editable: boolean;
}> = ({ value, row, column, onValueChange, options, editable }) => {
    const [editing, setEditing] = React.useState(false)

    // Apply the class directly based on the cell value
    const className = wellClassFormatter(value)

    if(!editable) {
        return <div className={className}>{value}</div>
    }

    if(editing) {
        return (
            <select
                value={value}
                onChange={(e) => {
                    onValueChange(e.target.value, row, column)
                    setEditing(false)
                }}
                onBlur={() => setEditing(false)}
                autoFocus
                className="form-select form-select-sm"
            >
                {options.map(option => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
        )
    }

    return (
        <div
            className={className}
            onClick={() => setEditing(true)}
            style={{
                cursor: 'pointer',
                margin: '-0.5rem',
                padding: '0.5rem',
                minWidth: 'calc(100% + 1rem)',
                maxWidth: 'calc(100% + 1rem)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            {value}
        </div>
    )
}